// Helper: validates UAE mobile number format
export function validateUAEMobile(phone: string): { isValid: boolean; error?: string } {
  const cleaned = phone.trim();

  // Empty is allowed for non-primary numbers
  if (!cleaned) {
    return { isValid: true };
  }

  // Remove spaces, dashes, and parentheses for validation
  const digitsOnly = cleaned.replace(/[\s\-()]/g, '');

  // Reject any leading + or non-digit characters — we only accept local 05 format
  if (!/^\d+$/.test(digitsOnly)) {
    return {
      isValid: false,
      error: 'Phone number must contain only digits and no leading +',
    };
  }

  // Must start with 05 and be exactly 10 digits (05XXXXXXXX)
  if (!digitsOnly.startsWith('05')) {
    return {
      isValid: false,
      error: 'Phone number must start with 05',
    };
  }

  if (digitsOnly.length !== 10) {
    return {
      isValid: false,
      error: 'Phone number must be exactly 10 digits (05XXXXXXXX)',
    };
  }

  return { isValid: true };
}
